import { useState } from 'react';

const PlatformPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Connect to API to save email for waitlist
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <div className="relative z-10 min-h-screen bg-gradient-to-b from-bg to-white py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-[1200px] mx-auto">
          
          {/* Main Hero Section */}
          <div className="text-center mb-16">
            <div className="inline-block bg-gradient-to-r from-primary to-secondary text-white px-6 py-2 rounded-full mb-6 shadow-lg">
              <span className="font-bold flex items-center gap-2">
                <i className="fas fa-rocket"></i>
                قريباً جداً
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary mb-6">
              منصة التعلم التفاعلية
            </h1>
            <p className="text-2xl md:text-3xl text-gray-800 mb-4 font-bold">
              تجربة تعليمية تفاعلية باش تتعلم وأنت مستمتع
            </p>
            <p className="text-xl text-gray-600 max-w-[800px] mx-auto">
              منصة تعليمية متطورة مع دروس تفاعلية، تحديات يومية، ونقاط باش نحفزوك على التعلم
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            {/* Feature 1 */}
            <div className="bg-white rounded-3xl p-8 shadow-custom-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-primary to-secondary rounded-2xl flex items-center justify-center mb-6">
                <i className="fas fa-gamepad text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-black text-gray-800 mb-4">تعلم تفاعلي</h3>
              <p className="text-gray-600 leading-relaxed">
                دروس تفاعلية ممتعة مع تمارين عملية وتحديات يومية باش التعلم يولي أشبه باللعب
              </p>
            </div>

            {/* Feature 2 */}
            <div className="bg-white rounded-3xl p-8 shadow-custom-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-primary to-secondary rounded-2xl flex items-center justify-center mb-6">
                <i className="fas fa-trophy text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-black text-gray-800 mb-4">نظام النقاط والشارات</h3>
              <p className="text-gray-600 leading-relaxed">
                اكسب النقاط والشارات مع كل درس تكمله، تنافس مع الآخرين، واحتفظ بسجل إنجازاتك الكاملة
              </p>
            </div>

            {/* Feature 3 */}
            <div className="bg-white rounded-3xl p-8 shadow-custom-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-primary to-secondary rounded-2xl flex items-center justify-center mb-6">
                <i className="fas fa-chart-line text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-black text-gray-800 mb-4">تتبع التقدم</h3>
              <p className="text-gray-600 leading-relaxed">
                راقب تطورك يوم بيوم، تابع إحصائياتك بالتفصيل، واعرف وين راك قوي ووين لازم تحسّن
              </p>
            </div>

            {/* Feature 4 */}
            <div className="bg-white rounded-3xl p-8 shadow-custom-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-primary to-secondary rounded-2xl flex items-center justify-center mb-6">
                <i className="fas fa-clock text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-black text-gray-800 mb-4">دروس قصيرة</h3>
              <p className="text-gray-600 leading-relaxed">
                دروس قصيرة من 5-10 دقائق، تناسب وقتك اليومي، تعلم متى ما حبيت ومن وين ما كنت
              </p>
            </div>
          </div>

          {/* Big Visual Section */}
          <div className="bg-gradient-to-br from-primary via-secondary to-primary-dark text-white rounded-3xl p-12 md:p-16 mb-16 shadow-custom-lg text-center">
            <div className="w-24 h-24 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-8">
              <i className="fas fa-graduation-cap text-white text-6xl"></i>
            </div>
            <h2 className="text-4xl md:text-5xl font-black mb-6">
              تجربة تعليمية احترافية ومبتكرة
            </h2>
            <p className="text-xl md:text-2xl opacity-90 max-w-[700px] mx-auto mb-8">
              منصة متكاملة للتعلم التفاعلي مع أحدث التقنيات التعليمية
            </p>
            <div className="flex flex-wrap gap-4 justify-center text-lg">
              <span className="bg-white/20 px-6 py-3 rounded-full backdrop-blur-sm flex items-center gap-2">
                <i className="fas fa-check-circle"></i> دروس تفاعلية
              </span>
              <span className="bg-white/20 px-6 py-3 rounded-full backdrop-blur-sm flex items-center gap-2">
                <i className="fas fa-star"></i> بطاقات تعليمية
              </span>
              <span className="bg-white/20 px-6 py-3 rounded-full backdrop-blur-sm flex items-center gap-2">
                <i className="fas fa-check-circle"></i> تعلم مخصص
              </span>
              <span className="bg-white/20 px-6 py-3 rounded-full backdrop-blur-sm flex items-center gap-2">
                <i className="fas fa-check-circle"></i> مجتمع طلاب
              </span>
            </div>
          </div>

          {/* Email Signup Section */}
          <div className="bg-white rounded-3xl p-12 shadow-custom-lg text-center max-w-[800px] mx-auto">
            <div className="w-16 h-16 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="fas fa-bell text-white text-2xl"></i>
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-gray-800 mb-4">
              كن أول من يعرف وقت نطلقو!
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              دخل الإيميل تاعك وراح نبلغوك فور ما نطلقو المنصة
            </p>
            
            {submitted ? (
              <div className="bg-green-100 border-2 border-green-500 text-green-700 px-6 py-4 rounded-xl text-lg font-bold">
                ✅ شكراً! تم تسجيلك بنجاح. سنتواصل معك قريباً!
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="flex flex-col md:flex-row gap-4 max-w-[600px] mx-auto">
                <input
                  type="email"
                  placeholder="بريدك الإلكتروني"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="flex-1 px-6 py-4 border-2 border-gray-200 rounded-xl focus:border-primary focus:outline-none text-lg"
                />
                <button
                  type="submit"
                  className="bg-gradient-to-r from-primary to-secondary text-white px-8 py-4 rounded-xl font-bold text-lg hover:opacity-90 transition-all duration-300 shadow-lg whitespace-nowrap flex items-center gap-2"
                >
                  <i className="fas fa-user-plus"></i>
                  انضم للقائمة
                </button>
              </form>
            )}
            
            <p className="text-gray-500 mt-6 text-sm">
              سنرسل لك تحديثات حصرية وعروض خاصة عند الإطلاق
            </p>
          </div>

          {/* Timeline/Progress Bar */}
          <div className="mt-16 bg-white rounded-3xl p-8 shadow-custom">
            <div className="flex items-center justify-center gap-3 mb-8">
              <i className="fas fa-map-marked-alt text-primary text-3xl"></i>
              <h3 className="text-2xl font-black text-gray-800">خارطة الطريق</h3>
            </div>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <i className="fas fa-check text-white text-3xl"></i>
                </div>
                <h4 className="font-bold text-gray-800 mb-2">المرحلة 1</h4>
                <p className="text-gray-600 flex items-center justify-center gap-2">
                  <i className="fas fa-check-circle text-green-500"></i>
                  البنية التحتية
                </p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse shadow-lg">
                  <i className="fas fa-cogs text-white text-3xl"></i>
                </div>
                <h4 className="font-bold text-gray-800 mb-2">المرحلة 2</h4>
                <p className="text-gray-600 flex items-center justify-center gap-2">
                  <i className="fas fa-spinner fa-spin text-primary"></i>
                  تطوير المنصة
                </p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-gray-300 to-gray-400 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <i className="fas fa-rocket text-white text-3xl"></i>
                </div>
                <h4 className="font-bold text-gray-800 mb-2">المرحلة 3</h4>
                <p className="text-gray-600 flex items-center justify-center gap-2">
                  <i className="fas fa-clock text-gray-500"></i>
                  الإطلاق الرسمي
                </p>
              </div>
            </div>
          </div>

          {/* CTA Back to Courses */}
          <div className="mt-16 text-center">
            <p className="text-xl text-gray-600 mb-6">في الوقت الحالي، يمكنك تصفح</p>
            <a
              href="/courses"
              className="inline-flex items-center gap-3 bg-primary text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-primary-dark transition-all duration-300 shadow-lg"
            >
              <i className="fas fa-book"></i>
              دوراتنا وكتبنا الرقمية
              <i className="fas fa-arrow-left"></i>
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PlatformPage;
